import styled from 'styled-components';
import { darken } from 'polished';
import device from 'config/device';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  height: calc(100% - 107px);
  background: #fff;
  padding: 0 3%;
  overflow: auto;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    h1 {
      color: var(--blueDark);
    }

    > div {
      display: flex;
      flex-direction: column;
      text-align: right;
      font-weight: 500;
    }
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  margin: 5px 0;
  border: 1px solid var(--grayDark);
  border-radius: 10px;
  font-weight: bold;

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--grayLight);
    border: 1px solid var(--grayDark);
    border-radius: 5px;
    padding: 0 20px;
    margin: -1px;
  }

  svg {
    cursor: pointer;
  }

  button {
    color: var(--blueDark);
    padding: 5px 15px;
    font-weight: bold;
    transition: background 0.2s;
    margin: 2px 0;

    &:hover {
      background: ${darken(0.02, '#fff')};
      border-radius: 10px;
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;

  @media ${device.mobileMinTabMax} {
    width: 100%;
    flex-direction: column;
  }

  .side {
    display: flex;
    flex-direction: column;
    width: 30%;
    border-right: 1px solid var(--gray);

    @media ${device.mobileMinTabMax} {
      flex-direction: column;
      width: 100%;
    }

    h2 {
      padding-top: 15px;
    }

    button {
      cursor: pointer;
      margin: 10px 5px;
      font-size: 0.9rem;
      text-align: justify;
    }
  }

  .content {
    width: 70%;
    padding: 10px;

    @media ${device.mobileMinTabMax} {
      display: flex;
      flex-direction: column;
      width: 100%;
      font-size: 0.7rem;
      padding: 0;
    }

    div {
      margin: 10px 5px;
      font-size: 1.1rem;
      white-space: pre-line;
      text-align: justify;
    }

    button {
      color: var(--blueDark);
      font-weight: bold;
    }

    p {
      font-size: 14px;
      color: var(--blueDark);
      font-weight: bold;
    }
  }

  .handle-request-repair {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;

    button {
      color: var(--blueDark);
      background: var(--yellowDark);
      font-weight: bold;
      font-size: 16px;
      padding: 10px 25px;
      box-sizing: border - box;
      box-shadow: 2px 2px 0 rgba(12, 13, 14, 0.15);
      transition: all cubic - bezier(0.165, 0.84, 0.44, 1) 0.25s;
      border-radius: 15px;

      &:hover {
        box-shadow: 1px 1px 0 rgba(12, 13, 14, 0.15);
        background: ${darken(0.06, '#f7c325')};
      }

      @media ${device.mobileMinTabMax} {
        padding: 0 15px;
        margin: 5px;
      }
    }
  }

  h1,
  h2 {
    text-align: justify;
    color: var(--blueDark);
  }
`;

export const SocialMediaFooter = styled.div`
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;

  img {
    cursor: pointer;
    margin: 0 3px;
    max-height: 33px;
  }
`;
